export default __webpack_public_path__ + "static/media/cash.5ce37653.svg";